import { DowntimeAlert } from '../components/DowntimeAlert/index.types';
import { HELPCENTER_BASE_URL } from '../constants/url';
import { get } from '../utils/fetch';

export const getDowntime: () => Promise<DowntimeAlert[]> = async () => {
    const { data } = await get(`${HELPCENTER_BASE_URL}/downtime?ongoing=true`);
    return data;
};
